var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.353,
    height: 18.362,
    viewBox: "0 0 19.353 18.362",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "feedback",
    transform: "translate(0.1 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90687",
    "data-name": "Path 90687",
    d: "M359.779,1.137,357.867-.775a.478.478,0,0,0-.675,0h0L351.456,4.96a.477.477,0,0,0-.14.338V7.21a.478.478,0,0,0,.478.478h1.912a.477.477,0,0,0,.338-.14l5.735-5.735a.478.478,0,0,0,0-.676h0Zm-6.271,5.6h-1.236V5.5L357.529.239l1.236,1.236Zm0,0",
    transform: "translate(-340.801 0.915)",
    fill: "#a6a6a6",
    stroke: "#a6a6a6",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90688",
    "data-name": "Path 90688",
    d: "M17.683,66.789a.478.478,0,0,0-.478.478v6.691a1.436,1.436,0,0,1-1.434,1.434h-4.78a.475.475,0,0,0-.287.1L7.647,77.782V75.87a.478.478,0,0,0-.478-.478H2.389A1.435,1.435,0,0,1,.955,73.958v-8.6a1.435,1.435,0,0,1,1.434-1.434h8.6a.478.478,0,1,0,0-.956h-8.6A2.392,2.392,0,0,0,0,65.355v8.6a2.392,2.392,0,0,0,2.39,2.39h4.3v2.39a.478.478,0,0,0,.765.382l3.7-2.772h4.62a2.392,2.392,0,0,0,2.39-2.39V67.267A.478.478,0,0,0,17.683,66.789Zm0,0",
    transform: "translate(0.001 -61.054)",
    fill: "#a6a6a6",
    stroke: "#a6a6a6",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90689",
    "data-name": "Path 90689",
    d: "M101.07,158.773H96.29a.478.478,0,1,0,0,.956h4.779a.478.478,0,1,0,0-.956Zm0,0",
    transform: "translate(-92.945 -153.993)",
    fill: "#a6a6a6",
    stroke: "#a6a6a6",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90690",
    "data-name": "Path 90690",
    d: "M96.29,255.541h4.779a.478.478,0,1,0,0-.956H96.29a.478.478,0,1,0,0,.956Zm0,0",
    transform: "translate(-92.945 -246.938)",
    fill: "#a6a6a6",
    stroke: "#a6a6a6",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90691",
    "data-name": "Path 90691",
    d: "M96.29,351.354h11.471a.478.478,0,0,0,0-.956H96.29a.478.478,0,1,0,0,.956Zm0,0",
    transform: "translate(-92.945 -339.883)",
    fill: "#a6a6a6",
    stroke: "#a6a6a6",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.9b5c5d653ea36f5a6ff3124bce21bd07.svg";
export { ForwardRef as ReactComponent };